import { useState, useEffect, useCallback } from "react";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*<>{}[]";

export function useTextScramble(finalText: string, { delay = 0, duration = 800 }: { delay?: number; duration?: number } = {}) {
  const [display, setDisplay] = useState("");
  const [resolved, setResolved] = useState(false);

  const prefersReducedMotion =
    typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    if (prefersReducedMotion) {
      setDisplay(finalText);
      setResolved(true);
      return;
    }

    const timeout = setTimeout(() => {
      const len = finalText.length;
      const intervalTime = 30;
      const totalFrames = Math.ceil(duration / intervalTime);
      let frame = 0;

      const interval = setInterval(() => {
        frame++;
        const progress = frame / totalFrames;

        const result = finalText
          .split("")
          .map((char, i) => {
            if (char === " ") return " ";
            // Characters resolve left-to-right based on progress
            const charThreshold = i / len;
            if (progress > charThreshold + 0.3) return char;
            return CHARS[Math.floor(Math.random() * CHARS.length)];
          })
          .join("");

        setDisplay(result);

        if (frame >= totalFrames) {
          clearInterval(interval);
          setDisplay(finalText);
          setResolved(true);
        }
      }, intervalTime);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [finalText, delay, duration, prefersReducedMotion]);

  return { display, resolved };
}
